import { Env } from "util/environment-helper";

export const Endpoints = {
  apiRoot: Env.apiRoot || "/api",
  pdfServiceRoot: Env.pdfApiRoot || "/pdf",
  copApiRoot: Env.copApiRoot || "/error",
  copWebLoginURL: Env.copWebLoginURL || "/error",
};
